export const actions = {
    SET_LAST_SEARCH: "SET_LAST_SEARCH"
};

export const setLastSearch = (object: any) => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_LAST_SEARCH,
            payload: object
        })
    }
};



// WEBPACK FOOTER //
// ./app/actions/lastSearchActions.ts